export default __webpack_public_path__ + "static/media/use_action_zc.b611faa1.png";